import { FC, useEffect, useRef } from "react";

interface RangeSliderProps {
  id: string;
  min: number;
  max: number;
  step: number;
  value: number;
  stepLabels: string[];
  isLeftLabel?: boolean;
  isTopLabel?: boolean;
  isBottomLabel?: boolean;
  leftLabel?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const RangeSlider: FC<RangeSliderProps> = ({
  id,
  min,
  max,
  step,
  value,
  stepLabels,
  isLeftLabel = false,
  isTopLabel = false,
  isBottomLabel = false,
  leftLabel = "",
  onChange,
}) => {

  const sliderRef = useRef<HTMLInputElement>(null);
  useEffect(() => {
    const percentage = ((value - min) / (max - min)) * 100;
    if (sliderRef.current) {
      sliderRef.current.style.backgroundImage = `linear-gradient(to right, #2563eb ${percentage}%, #d1d5db ${percentage}%)`;
    }
  }, [value, min, max]);
  return (
      <div className="w-full flex gap-2 items-end">
        {isLeftLabel && (
          <label htmlFor={id} className="w-1/3 text-sm font-semibold text-gray-500 align-bottom">
            {leftLabel}
          </label>
        )}
        <div className="w-full">
          {isTopLabel && (
            <div className="w-full flex justify-between text-xs text-gray-500 px-1">
              {stepLabels?.map((label, index) => (
                <span key={index}>{label}</span>
              ))}
            </div>
          )}
          <input
            ref={sliderRef}
            id={id}
            type="range"
            min={min}
            max={max}
            step={step}
            value={value}
            onChange={onChange}
            className="w-full h-3 bg-gray-300 rounded-lg cursor-pointer appearance-none focus:outline-none"
          />
          {isBottomLabel && (
            <div className="w-full flex justify-between text-xs text-gray-500 px-1">
              {stepLabels?.map((label, index) => (
                <span key={index}>{label}</span>
              ))}
            </div>
          )}
        </div>
      </div>
  );
};

export default RangeSlider;
